import React, { useCallback } from 'react';
import { navigate } from 'gatsby';

import {
    Container,
    className,
    Row,
    Col,
    Heading,
    isMobile
} from 'aplazame-design-system';
import TransitionLink from 'aplazame-design-system/src/components/TransitionLink';
import { useTranslate } from 'soluble-gatsby-source';

import BlogItemComponent from '../BlogItemComponent';
import NewsletterHubspotForm from '../NewsletterHubspotForm';

import style from './style.module.scss';


export default function WordpressPostsSection({
    id,
    title,
    titleTag,
    posts,
    hasPagination,
    nextPageSlug,
    prevPageSlug,
    showWordpressStickyPosts,
    hubspotFormId,
    hubspotPortalId
}) {
    const translation = useTranslate();

    const onClickNext = useCallback(
        e => {
            e.preventDefault();
            navigate(`${window.location.pathname}2/`);
        },
        []
    );

    let newPosts = hubspotFormId && hubspotPortalId ? [
        ...posts.slice(0, 3),
        null,
        ...posts.slice(3, 99)
    ] : posts;

    return (
        <section aria-labelledby={id}>
            <Container
                pt={{ xs: 10 }}
                pb={{ xs: 5 }}
            >
                <Row>
                    <Col
                        data-sal="slide-up"
                        data-sal-easing="ease-out-quart"
                    >
                        <Heading
                            id={id}
                            tag={titleTag}
                            className="h3 font-weight-bold mb-5"
                        >
                            {title}
                        </Heading>
                    </Col>
                    {newPosts.map((p, i) => (
                        <Col
                            key={i}
                            col={{ lg: showWordpressStickyPosts ? 6 : 3 }}
                            pb={{ xs: 5, lg: 10 }}
                            data-sal="slide-up"
                            data-sal-easing="ease-out-quart"
                            data-sal-delay={`xs-none--lg-${(i % (showWordpressStickyPosts ? 2 : 4)) * 100}`}
                        >
                            {p ? (
                                <BlogItemComponent
                                    {...p}
                                    imageAspectRatio={showWordpressStickyPosts && !isMobile() ? 1.57 : null}
                                />
                            ) : (
                                <NewsletterHubspotForm
                                    hubspotFormId={hubspotFormId}
                                    hubspotPortalId={hubspotPortalId}
                                />
                            )}
                        </Col>
                    ))}
                </Row>
                {hasPagination || nextPageSlug || prevPageSlug ? (
                    <Row className="pb-10 pt-5">
                        <Col col={{ xs: 6 }}>
                            {prevPageSlug ? (
                                <TransitionLink
                                    to={prevPageSlug}
                                    {...className(`body d-block ${style.pagelink} ${style['pagelink--prev']}`)}
                                >
                                    {typeof window !== 'undefined' ? new DOMParser().parseFromString(translation['blog-pagination.previous-page'].text, "text/html").documentElement.textContent : ""}
                                </TransitionLink>
                            ) : null}
                        </Col>
                        <Col className="text-right" col={{ xs: 6 }}>
                            {hasPagination ? (
                                <a
                                    onClick={onClickNext}
                                    href="2/"
                                    {...className(`body d-block ${style.pagelink} ${style['pagelink--next']}`)}
                                >
                                    {typeof window !== 'undefined' ? new DOMParser().parseFromString(translation['blog-pagination.next-page'].text, "text/html").documentElement.textContent : ""}
                                </a>
                            ) : null}
                            {nextPageSlug ? (
                                <TransitionLink
                                    to={nextPageSlug}
                                    {...className(`body d-block ${style.pagelink} ${style['pagelink--next']}`)}
                                >
                                    {typeof window !== 'undefined' ? new DOMParser().parseFromString(translation['blog-pagination.next-page'].text, "text/html").documentElement.textContent : ""}
                                </TransitionLink>
                            ) : null}
                        </Col>
                    </Row>
                ) : null}
            </Container>
        </section>
    );
}
